export function galleryFromProduct(product) {
  if (!product) {
    return [];
  }

  if (Array.isArray(product.gallery) && product.gallery.length) {
    return [...product.gallery];
  }

  const single = product.front_image || product.image;

  return single ? [single] : [];
}

export function coverImage(gallery = []) {
  return gallery[0] || '';
}
